/***
 *
 * @param levels nof levels in tree (depth of tree)
 * @param nc number of children per node of the tree (4 or 8)
 * @returns {number}
 */
export function getFlattenedTreeSize(levels: number, nc: number): number {
    return Math.floor((nc * Math.pow(nc, levels) - 1) / (nc - 1));
}

export function getIndexToFlattenedTree(address: any): number {
    if (address.level === 0) {
        return 0;
    }

    // we have not the index of level begin nad we need the index based on the address
    return getFlattenedTreeSize(address.level - 1, address.patchInfo.nc) + address.layer * Math.pow(4, address.level) + address.row * Math.pow(2, address.level) + address.col;
}

export function getIndexToFlattenedTree3(level: number, layer: number, row: number, col: number, nc: number) {
    if (level === 0) {
        return 0;
    }

    // we have not the index of level begin nad we need the index based on the address
    return getFlattenedTreeSize(level - 1, nc) + layer * Math.pow(4, level) + row * Math.pow(2, level) + col;
}
